// Shared MapLibre GL instance using the CSP build.
//
// The regular maplibre-gl build inlines its Web Worker as a Blob string that is
// eval'd at runtime. CRA/terser minification mangles identifiers in a way that
// breaks that eval'd worker in the PRODUCTION bundle ("ReferenceError: s is not
// defined"), so vector tiles never decode and the map renders black. The CSP
// build instead loads the worker from an external URL — we ship MapLibre's own
// pre-built worker from /public, sidestepping the minification bug entirely.
import maplibregl from "maplibre-gl/dist/maplibre-gl-csp";

maplibregl.workerUrl = `${process.env.PUBLIC_URL || ""}/maplibre-gl-csp-worker.js`;

export default maplibregl;
